<template>
  <div class="txt_box">
    <div :class="['banner-left', semTestPlan === 'planC' ? 'set-margin-top' : '']">
      <img class="img" src="@/assets/images/sempc-logo.png" alt="" />
      <div class="banner-desc">浙江省“最多跑一次”电子签名指定供应商</div>
      <div class="banner-title">合法可靠的一站式电子合同服务</div>
      <div class="banner-tab">
        电子签名&nbsp;&nbsp;｜&nbsp;&nbsp;智能合同&nbsp;&nbsp;｜&nbsp;&nbsp;印章管控&nbsp;&nbsp;｜&nbsp;&nbsp;身份认证
      </div>
      <!-- B方案展示的按钮 -->
      <div class="btn_sqsy" @click="trialClick" v-if="semTestPlan === 'planB'">申请试用</div>
    </div>
    <!-- semtestBannerForm 表示 20221011需求，abTest分流中，b方案：点击按钮，显示留资弹框，原本banner上的form表单隐藏，关闭弹框显示banner上的form表单 -->
    <div class="toTry hidden-sm" v-show="semtestBannerForm">
      <div class="try-tit">免费试用</div>
      <div class="tel-line">
        <span class="des">销售热线：</span>
        <span class="tel">{{ info.tel }}</span>
      </div>

      <!-- B方案 -->
      <div class="line" v-if="semTestPlan === 'planB'">
        <input
          :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active_input' : '']"
          v-model="name"
          type="text"
          class="userName"
          placeholder="您的姓名"
          @focus="clearData(0)"
          @blur="onfousFun()"
        />
      </div>
      <!-- 20230413迭代，使用abtest分流:①.name_input表示（老）留资企业名称，不使用公司联想功能，②.name_association表示（新）留资企业名称，使用公司联想功能 -->
      <div class="line" :class="{'company-position': abTestPlan !== 'name_input'}" v-if="semTestPlan === 'planB'">
        <input
          v-if="abTestPlan === 'name_input'"
          :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称（必填）"
          @focus="clearData(1)"
          @blur="onfousFun()"
        />
        <input
          v-else
          :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称"
          @focus="clearData(1)"
          @blur="onfousFun()"
          @keyup.enter="handleAssociativeInputSearch()"
          @input="() => changeInput()"
        />
        <!-- 20230413：增加企业名称支持联想输入 -->
        <transition name="el-fade-in-linear" v-if="abTestPlan !== 'name_input'">
          <div class="company-list" v-if="companyList.length && companyName && showCompanyList">
            <p v-for="item in companyList" :key="item.certNo" @click="chooseOrg(item)" v-html="item.name"></p>
          </div>
        </transition>
      </div>
      <div class="line">
        <input
          :class="[(isClick && phoneNumber == '') || phoneNumber == '请输入您的联系方式' ? 'active_input' : '']"
          v-model="phoneNumber"
          id="mobile"
          type="text"
          class="mobile"
          placeholder="手机号码"
          @focus="clearData(2)"
          @blur="onfousFun()"
        />
      </div>

      <div class="line">
        <div class="code-box code-box-boder">
          <input
            :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active_input' : '']"
            v-model="phoneCode"
            maxlength="6"
            type="text"
            class="code-input form-control code no_border"
            placeholder="验证码"
            @focus="clearData(3)"
            @blur="onfousFun()"
          />
          <span
            :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']"
            class="code-btn"
            id="code-btn"
            @click="handleFetchCodeClick()"
            >{{ codeName }}</span
          >
        </div>
      </div>
      <!-- C方案展开的四要素 -->
      <div class="line" v-if="semTestPlan === 'planC' && fourElementsFlag">
        <input
          :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active_input' : '']"
          v-model="name"
          type="text"
          class="userName"
          placeholder="您的姓名（必填）"
          @focus="clearData(0)"
          @blur="onfousFun()"
        />
      </div>
      <!-- 20230413迭代，使用abtest分流:①.name_input表示（老）留资企业名称，不使用公司联想功能，②.name_association表示（新）留资企业名称，使用公司联想功能 -->
      <div class="line" :class="{'company-position': abTestPlan !== 'name_input'}" v-if="semTestPlan === 'planC' && fourElementsFlag">
        <input
          v-if="abTestPlan === 'name_input'"
          :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称（必填）"
          @focus="clearData(1)"
          @blur="onfousFun()"
        />
        <input
          v-else
          :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称（必填）"
          @focus="clearData(1)"
          @blur="onfousFun()"
          @keyup.enter="handleAssociativeInputSearch()"
          @input="() => changeInput()"
        />
        <!-- 20230413：增加企业名称支持联想输入 -->
        <transition name="el-fade-in-linear" v-if="abTestPlan !== 'name_input'">
          <div class="company-list" v-if="companyList.length && companyName && showCompanyList">
            <p v-for="item in companyList" :key="item.certNo" @click="chooseOrg(item)" v-html="item.name"></p>
          </div>
        </transition>
      </div>
      <div class="mb-20">
        <!-- 只是空行，控制按钮与上面输入框的距离 -->
      </div>
      <div class="line agreement-line" v-if="userAgreement.enable">
        <label class="wrapper">
          <input type="checkbox" v-model="agreement" />
          <span>我已阅读并同意<span style="color:#1890ff;" @click.prevent="showProtocal">《隐私政策》</span></span>
        </label>
        <div v-show="showErrorTip" class="error-tip">请先阅读并同意隐私政策</div>
      </div>
      <!-- rightstart（开屏右侧）用于埋点上报 -->
      <div class="btn-try" :class="changeBtnBg ? 'bg_active1' : 'bg_active0'" @click="handleSendInfoBtnClick('rightstart')" data-agl-cvt="5">
        {{ tryButtontxt }}
      </div>
      <!-- 客服可能联系，这句话只有在c方案，并且是双要素的时候显示，四要素的时候不显示 -->
      <div class="botton-text" v-if="semTestPlan === 'planC' && !fourElementsFlag">*客服可能会在1-2个工作日联系您</div>
    </div>

    <!-- 弹框组件 -->
    <UseDialog ref="dialogForm" />
    <!-- 阅读协议 -->
    <Protocol :visible.sync="protocolVisible" :type="protocolType" />
  </div>
</template>

<script>
import { hostToBusinessInfo } from '@/utils'
import formMixin from '../mixins/form.js'
import { mapState, mapMutations } from 'vuex'
export default {
  mixins: [formMixin],
  components: {
    UseDialog: () => import('./UseDialog.vue'),
    Protocol: () => import('@/components/Protocol.vue'),
  },
  data() {
    return {
      closeForm: true,
      fourElementsFlag: false, // 控制双要素变为四要素
      protocolVisible: false,
      protocolType: 'privacy',
      showErrorTip: false,
    }
  },
  watch: {
    closeForm(v, oldV) {
      this.$emit('setShowSuccessDialog', !v)
    },
    phoneCode: {
      // 当验证码输入够6位数字时，从双要素换成四要素
      handler(newVal) {
        let numReg = /^\d{6}$/
        if (numReg.test(newVal) && newVal.length === 6) {
          this.fourElementsFlag = true // 显示四要素
        }
      },
    },
    companyName(newVal, oldVal) {
      if(newVal) {
        this.companyList = []
        this.showCompanyList = true
      }
    }
  },
  props: {
    landingPageName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('semTest', ['uuidInfo', 'semTestPlan', 'semtestBannerForm']),
    ...mapState('abTest', ['abTestPlan']),
    info() {
      return hostToBusinessInfo()
    },
  },
  methods: {
    ...mapMutations('semTest', ['setSemtestBnnnerForm']),
    showProtocal() {
      this.protocolVisible = true
    },
    trialClick() {
      // abTest分流埋点,方案b,banner下方【申请试用】点击
      this.$tsignData.track('sempc_banner_test_firstapply', {
        uuid: this.uuidInfo, // 用户唯一标识
      })
      // bannerdown,是【用户入口:banner下方】的标识
      this.$refs.dialogForm.showDialog('bannerdown')
      this.setSemtestBnnnerForm(false) // b方案中，点击按钮，banner上的form表单隐藏
    },
  },
}
</script>

<style lang="less" scoped>
@media (max-width: 1190px) {
  .txt_box {
    justify-content: flex-start !important;
    .banner-left {
      margin-left: 40px;
    }
  }
}
.txt_box {
  width: 1200px;
  position: relative;
  display: flex;
  align-items: flex-start;
  .set-margin-top {
    margin-top: 100px !important;
  }
  .banner-left {
    margin-top: 70px;
    color: #ffffff;
    .img {
      width: 125px;
      height: 38px;
    }
    .banner-desc {
      font-size: 20px;
      margin-top: 30px;
    }
    .banner-title {
      font-size: 50px;
      margin: 20px 0 30px 0;
    }
    .banner-tab {
      font-size: 20px;
    }
    .btn_sqsy {
      width: 180px;
      height: 54px;
      background: #e63740;
      border-radius: 4px;
      font-size: 18px;
      color: #ffffff;
      line-height: 54px;
      text-align: center;
      margin-top: 60px;
      cursor: pointer;
    }
  }
  .title {
    width: 489px;
    height: 227px;
    //background-image: url('@/assets/images/bannerForm.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 113px;
  }

  .toTry {
    width: 348px;
    font-size: 16px;
    margin-top: 57px;
    margin-left: 124px;
    padding-bottom: 28px;
    box-shadow: 6px 6px 13px 10px rgba(2, 6, 11, 0.23);
    background: #fff;
  }
  @media (max-width: 1290px) {
    .toTry {
      margin-left: 30px;
    }
  }
  @media (max-width: 1190px) {
    .toTry {
      margin-left: 20px;
    }
    .banner-title {
      width: 640px;
    }
  }
  @media (max-width: 1080px) {
    .toTry {
      margin-left: 20px;
    }
    .banner-title {
      width: 530px;
    }
  }
  @media (max-width: 985px) {
    .toTry {
      margin-left: 20px;
    }
    .banner-title {
      width: 460px;
    }
  }
  @media (max-width: 910px) {
    .toTry {
      margin-left: 20px;
    }
    .banner-title {
      width: 400px;
    }
  }
  @media (max-width: 880px) {
    .toTry {
      margin-left: 20px;
    }
    .banner-title {
      width: 370px;
    }
    .banner-tab {
      font-size: 16px !important;
    }
  }
  a {
    display: block;
    text-decoration: none;
  }

  .line {
    width: 300px;
    height: 40px;
    position: relative;
    margin: 0 auto 10px;

    .form-control.code {
      width: 170px !important;
      padding-left: 20px !important;
    }

    .active_c {
      color: #ccc;

      &1 {
        color: #297acc;
      }
    }
  }
  .company-position {
    position: relative;
    .company-list {
      position: absolute;
      top: 44px;
      width: 300px;
      line-height: 28px;
      max-height: 142px;
      overflow-y: auto;
      background: #fff;
      z-index: 1;
      padding: 10px;
      font-size: 14px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      color: #2D3E50;
      p:hover {
        cursor: pointer;
        background: #f3f3f3;
      }
    }
    .company-list::-webkit-scrollbar {
      width: 8px;
      height: 1px;
    }
    .company-list::-webkit-scrollbar-thumb {
      border-radius: 10px;  
      background: #c0bfbf;  box-shadow: inset 0 0 5px #eae8e8;
    }
    .company-list::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ededed;
      box-shadow: inset 0 0 5px rgba( 0, 0, 0, .1);
    }
  }
  .mb-20 {
    margin-bottom: 20px;
  }

  .code-box {
    position: relative;

    .no_border {
      border: 0;
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
        border-color: #fa485a;
      }
    }
  }

  .code-box-boder {
    border: 1px solid #ebebeb;
  }

  .code-btn {
    width: 113px;
    height: 40px;
    border-radius: 2px;
    position: absolute;
    text-align: right;
    right: 20px;
    top: 0;
    bottom: 0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    line-height: 40px;
    cursor: pointer;

    &.disabled {
      background: #ccc;
      color: #fff;
    }
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .bg_active0 {
    background: #e61717 !important;
  }

  .bg_active1 {
    background: rgba(230, 23, 23, 0.5) !important;
  }

  input {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    width: 100%;
    display: block;
    height: 40px;
    border: 1px solid #ebebeb;
    padding: 6px 20px;
    color: #333;
    outline: 0;
  }

  .btn_zc {
    width: 300px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #297acc;
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .try-tit-cs {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: #333;
    line-height: 25px;
    font-weight: 700;
    padding: 21px 0;
    text-align: center;
  }

  .try-tit {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: #333;
    line-height: 25px;
    font-weight: 700;
    padding: 21px 0 0 0;
    text-align: center;
  }

  .tel-line {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC-Medium;
    line-height: 25px;
    padding-top: 15px;
    padding-bottom: 15px;
    .des {
      color: #333;
    }
    .tel {
      color: #e61717;
    }
  }
  .agreement-line {
    margin-bottom: 25px;
  }
  .btn-try {
    width: 300px;
    height: 45px;
    border-radius: 4px;
    margin: 0 auto 15px;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
    font-size: 18px;
    font-family: PingFangSC-Regular;
    color: #fff;
  }
  .botton-text {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.35);
    text-align: center;
  }
}
.hg-5 {
  height: 5px !important;
}

.txt_box .agreement-line {
  height: auto;
  color: #000;
  .wrapper {
    display: flex;
    align-items: center;
  }
  input {
    width: 14px;
    height: 14px;
    display: inline-block;
  }
  span {
    font-size: 13px;
    margin-left: 6px;
  }
  a {
    display: inline-block;
    font-size: 13px;
    color: #1890ff;
  }
  .error-tip {
    font-size: 12px;
    color: red;
    position: absolute;
    bottom: -18px;
  }
}
</style>

<style lang="less">
@import '../mixins/bot.less';

.txt_box {
  .bot_slide_pc(@slideHeight: 40px, @slideWidth: 300px);
}
</style>
